import styles from './Groups.module.scss';
import { SupplierGroup } from 'types';
import { RemoveGroupCell } from '../RemoveGroupCell/RemoveGroupCell';
import { Add } from '@mui/icons-material';
import { AddGroupModal } from '../AddGroupModal/AddGroupModal';

import { DataTable, DataTableProps } from 'components/data/DataTable/DataTable';
import { OpenModalButton } from 'components/button/OpenModalButton/OpenModalButton';

export interface GroupsProps {
    groups: SupplierGroup[];
    supplierId: string;
    /** Callback to alert parent component that Groups has been updated. */
    updateGroups: React.Dispatch<React.SetStateAction<SupplierGroup[]>>;
}

export const Groups = ({ groups, supplierId, updateGroups }: GroupsProps) => {
    const removeGroup = (groupToRemove: string): void => {
        const updatedGroups = groups.filter((group: SupplierGroup) => {
            return group.name !== groupToRemove;
        });

        updateGroups(updatedGroups);
    };

    const addGroup = (newGroup: SupplierGroup): void => {
        const updatedGroups = [...groups, newGroup];
        updateGroups(updatedGroups);
    };

    const columns: DataTableProps['columns'] = [
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            sortingOrder: ['asc', 'desc'],
        },
        {
            field: 'description',
            headerName: 'Description',
            flex: 1,
            sortingOrder: ['asc', 'desc'],
        },
        {
            field: 'remove',
            headerName: 'Remove',
            renderCell: (params) => (
                <RemoveGroupCell
                    params={params}
                    supplierId={supplierId}
                    onRemoveGroup={removeGroup}
                />
            ),
            sortable: false,
            maxWidth: 100,
            disableExport: true,
        },
    ];

    return (
        <div data-testid="Groups" className={styles.container}>
            <DataTable
                id="organizationGroups"
                data={groups ?? []}
                dataFormatter={(groups) => groups}
                columns={columns}
                getRowId={(group) => group.name}
                getRowCount={() => groups.length}
                disableSelectionOnClick
                disableColumnMenu
                csvOptions={{
                    fileName: 'groups',
                }}
                toolbarComponents={
                    <OpenModalButton
                        icon={<Add />}
                        modal={AddGroupModal}
                        className={styles.openModal}
                        modalProps={{
                            supplierId: supplierId,
                            onAddGroup: addGroup,
                            groups: groups,
                        }}
                    >
                        Add Group
                    </OpenModalButton>
                }
            />
        </div>
    );
};
